import React from 'react';
import './passwordResetSuccess.scss';

const PasswordResetSuccess = () => {
  return (
    <div className="password-reset-success">
      <div className="success-container">
        <div className="success-icon">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="24" height="24">
            <path d="M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm-2 15l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"/>
          </svg>
        </div>
        <h1>Password Reset Successful!</h1>
        <p>You can now log in with your new password to place your new rental or manage rentals via Renticy app.</p>
      </div>
    </div>
  );
};

export default PasswordResetSuccess;
